/**
* @vue/shared v3.5.18
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function s(e) {
  const t = /* @__PURE__ */ Object.create(null);
  for (const o of e.split(","))
    t[o] = 1;
  return (o) => o in t;
}
const G = process.env.NODE_ENV !== "production" ? Object.freeze({}) : {}, L = process.env.NODE_ENV !== "production" ? Object.freeze([]) : [], V = () => {
}, F = () => !1, U = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // uppercase letter
(e.charCodeAt(2) > 122 || e.charCodeAt(2) < 97), $ = (e) => e.startsWith("onUpdate:"), H = Object.assign, I = (e, t) => {
  const o = e.indexOf(t);
  o > -1 && e.splice(o, 1);
}, S = Object.prototype.hasOwnProperty, q = (e, t) => S.call(e, t), m = Array.isArray, O = (e) => f(e) === "[object Map]", T = (e) => f(e) === "[object Set]", l = (e) => typeof e == "function", r = (e) => typeof e == "string", h = (e) => typeof e == "symbol", c = (e) => e !== null && typeof e == "object", J = (e) => (c(e) || l(e)) && l(e.then) && l(e.catch), g = Object.prototype.toString, f = (e) => g.call(e), K = (e) => f(e).slice(8, -1), M = (e) => f(e) === "[object Object]", Y = (e) => r(e) && e !== "NaN" && e[0] !== "-" && "" + parseInt(e, 10) === e, W = /* @__PURE__ */ s(
  // the leading comma is intentional so empty string "" is also included
  ",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"
), Z = /* @__PURE__ */ s(
  "bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo"
), p = (e) => {
  const t = /* @__PURE__ */ Object.create(null);
  return (o) => t[o] || (t[o] = e(o));
}, w = /-(\w)/g, Q = p(
  (e) => e.replace(w, (t, o) => o ? o.toUpperCase() : "")
), j = /\B([A-Z])/g, X = p(
  (e) => e.replace(j, "-$1").toLowerCase()
), A = p((e) => e.charAt(0).toUpperCase() + e.slice(1)), v = p(
  (e) => e ? `on${A(e)}` : ""
), ee = (e, t) => !Object.is(e, t), te = (e, ...t) => {
  for (let o = 0; o < e.length; o++)
    e[o](...t);
}, oe = (e, t, o, n = !1) => {
  Object.defineProperty(e, t, {
    configurable: !0,
    enumerable: !1,
    writable: n,
    value: o
  });
}, ne = (e) => {
  const t = parseFloat(e);
  return isNaN(t) ? e : t;
}, re = (e) => {
  const t = r(e) ? Number(e) : NaN;
  return isNaN(t) ? e : t;
};
let u;
const se = () => u || (u = typeof globalThis != "undefined" ? globalThis : typeof self != "undefined" ? self : typeof window != "undefined" ? window : typeof global != "undefined" ? global : {});
function N(e) {
  if (m(e)) {
    const t = {};
    for (let o = 0; o < e.length; o++) {
      const n = e[o], i = r(n) ? E(n) : N(n);
      if (i)
        for (const a in i)
          t[a] = i[a];
    }
    return t;
  } else if (r(e) || c(e))
    return e;
}
const _ = /;(?![^(]*\))/g, C = /:([^]+)/, B = /\/\*[^]*?\*\//g;
function E(e) {
  const t = {};
  return e.replace(B, "").split(_).forEach((o) => {
    if (o) {
      const n = o.split(C);
      n.length > 1 && (t[n[0].trim()] = n[1].trim());
    }
  }), t;
}
function P(e) {
  let t = "";
  if (r(e))
    t = e;
  else if (m(e))
    for (let o = 0; o < e.length; o++) {
      const n = P(e[o]);
      n && (t += n + " ");
    }
  else if (c(e))
    for (const o in e)
      e[o] && (t += o + " ");
  return t.trim();
}
const R = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot", x = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view", z = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics", ie = /* @__PURE__ */ s(R), ce = /* @__PURE__ */ s(x), ae = /* @__PURE__ */ s(z), k = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly", le = /* @__PURE__ */ s(k);
function me(e) {
  return !!e || e === "";
}
const b = (e) => !!(e && e.__v_isRef === !0), D = (e) => r(e) ? e : e == null ? "" : m(e) || c(e) && (e.toString === g || !l(e.toString)) ? b(e) ? D(e.value) : JSON.stringify(e, y, 2) : String(e), y = (e, t) => b(t) ? y(e, t.value) : O(t) ? {
  [`Map(${t.size})`]: [...t.entries()].reduce(
    (o, [n, i], a) => (o[d(n, a) + " =>"] = i, o),
    {}
  )
} : T(t) ? {
  [`Set(${t.size})`]: [...t.values()].map((o) => d(o))
} : h(t) ? d(t) : c(t) && !m(t) && !M(t) ? String(t) : t, d = (e, t = "") => {
  var o;
  return (
    // Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    h(e) ? `Symbol(${(o = e.description) != null ? o : t})` : e
  );
};
export {
  L as EMPTY_ARR,
  G as EMPTY_OBJ,
  F as NO,
  V as NOOP,
  Q as camelize,
  A as capitalize,
  oe as def,
  H as extend,
  se as getGlobalThis,
  ee as hasChanged,
  q as hasOwn,
  X as hyphenate,
  me as includeBooleanAttr,
  te as invokeArrayFns,
  m as isArray,
  Z as isBuiltInDirective,
  l as isFunction,
  ie as isHTMLTag,
  Y as isIntegerKey,
  O as isMap,
  ae as isMathMLTag,
  $ as isModelListener,
  c as isObject,
  U as isOn,
  M as isPlainObject,
  J as isPromise,
  W as isReservedProp,
  ce as isSVGTag,
  T as isSet,
  le as isSpecialBooleanAttr,
  r as isString,
  h as isSymbol,
  ne as looseToNumber,
  s as makeMap,
  P as normalizeClass,
  N as normalizeStyle,
  g as objectToString,
  E as parseStringStyle,
  I as remove,
  D as toDisplayString,
  v as toHandlerKey,
  re as toNumber,
  K as toRawType,
  f as toTypeString
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/@vue_shared@3.5.18/~/@vue/shared/dist/shared.esm-bundler.js
// module id = 16
// module chunks = 41